import { render, staticRenderFns } from "./TheHero.vue?vue&type=template&id=5b9a591d&"
import script from "./TheHero.vue?vue&type=script&lang=js&"
export * from "./TheHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports